import page from './page';
import user from './user';
import lifeEventCategory from './lifeEventCategory';
import lifeEventTheme from './lifeEventTheme';
import lifeEvent from './lifeEvent';
import sampleLifeEventCategory from './sampleLifeEventCategory';
import sampleLifeEvent from './sampleLifeEvent';
import sampleLifeEventTheme from './sampleLifeEventTheme';
import sampleEncouragement from './sampleEncouragement';
import encouragement from './encouragement';
import customEncouragement from './customEncouragement';
import tag from './tag';
import specialTag from './specialTag';
import tagQuestion from './tagQuestion';
import hallmarkHoliday from './hallmarkHoliday';
import company from './company';
import document from './document';

export default {
  user,
  page,
  lifeEventCategory,
  lifeEventTheme,
  lifeEvent,
  sampleLifeEvent,
  sampleLifeEventCategory,
  sampleLifeEventTheme,
  sampleEncouragement,
  encouragement,
  customEncouragement,
  tag,
  specialTag,
  tagQuestion,
  hallmarkHoliday,
  company,
  document,
};



// WEBPACK FOOTER //
// ./src/schemas/admin/index.js